// src/data/books/blockchain/fundamentos/blockchain_fundamentos_ch01.js
const BLOCKCHAIN_FUNDAMENTOS_CH01 = {
  id: "blockchain-fundamentos-1",
  slug: "origen-y-evolucion",
  contentId: 1,
  title: "Origen y Evolución de Blockchain", // ← título nuevo
  sections: [
    {
      id: "hero",
      heading: "Origen y Evolución de Blockchain",
      text: `En este capítulo conocerás las bases y los pilares de la tecnología Blockchain,
cómo surge, cómo evoluciona y por qué hoy está tan presente en soluciones del mundo real.
A lo largo del libro profundizaremos tanto en conceptos teóricos como en fundamentos
técnicos que te permitirán entender criptomonedas, redes, y contratos inteligentes.`
    },
    {
      id: "origen-1991",
      heading: "De sellado temporal digital (1991) a Bitcoin (2008)",
      text: `La primera propuesta vinculada al concepto de “cadena de bloques” se remonta a 1991,
cuando se plantea un registro digital de archivos —audio, imagen, video o texto— ordenado
cronológicamente para certificar su fecha de creación mediante sellado temporal.`,
      image: {
            src: "https://raw.githubusercontent.com/AppsDevsLeon/ImagesBooks/refs/heads/main/imagesFundamentosBlockchain/cap2_0.png",
            alt: "Esquema de inmutabilidad",
            caption: "Los cambios se añaden mediante nuevas transacciones"
          },

    },
    
    {
      id: "bitcoin-2008",
      heading: "Bitcoin y el salto de concepto a red (2008)",
      
      text: `En 2008 nace Bitcoin: una red que utiliza Blockchain para ofrecer pagos electrónicos
sin supervisión centralizada ni control de instituciones financieras. El ingrediente clave
que consolida su éxito es la combinación de una cadena de bloques con un protocolo de
consenso denominado Proof-of-Work (PoW).`
    },
    
    {
      id: "ecosistema",
      heading: "Expansión del ecosistema",
      text: `Tras el éxito de Bitcoin, surgieron miles de criptoactivos con variaciones técnicas.
Más allá de las monedas, la tecnología Blockchain se extiende como herramienta transversal
en múltiples áreas debido a su inmutabilidad, trazabilidad y descentralización.`,
   image: {
        src: "https://raw.githubusercontent.com/AppsDevsLeon/ImagesBooks/refs/heads/main/imagesFundamentosBlockchain/cap2_2.png",
        alt: "Línea de tiempo de las monedas digitales",
        caption: "Línea de tiempo con hitos de dinero electrónico y criptomonedas: ecash (1983), Mondex y E-gold (1996), Bitcoin (2008), Litecoin (2010), Ripple (2013), Apple Pay (2015), Tether (2017), Bitcoin Cash y Coincheck (2018), Bakkt (2020) y Mastercard (2021), entre otros.",
 
      },
    },


    {
      id: "aplicaciones",
      heading: "Aplicaciones destacadas",
      list: [
        "Registro y certificación de documentos",
        "Historias clínicas e interoperabilidad en salud",
        "Registro de propiedad y trazabilidad de activos",
        "Gestión y distribución de energía",
        "Aduanas y logística",
        "Sistemas de votación",
        "Identidad digital",
        "Monitoreo de procesos productivos"
      ]
    },
    {
      id: "clave",
      heading: "Idea clave",
      text: `Blockchain combina un registro inmutable con consenso distribuido (como PoW),
lo que permite coordinar agentes sin una autoridad central y habilita nuevos modelos
de confianza para datos y valor.`
    }
  ]
};

export default BLOCKCHAIN_FUNDAMENTOS_CH01;
